import LiveUpdateController from './LiveUpdateController.vue';

export default LiveUpdateController;
